import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { RequestPriceModel } from "@models/requestPrice/requestPriceModel"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class PricingApprovalService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PricingApproval/GetAll", {
      params,
    })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PricingApproval/Get", {
      params: { id },
    })
    const { result } = res.data
    return RequestPriceModel.assign(result)
  }

  /** Xuất Excel danh sách căn của đúng một phiếu trình giá (BE: PricingApproval/ExportPricingApprovalUnit). */
  public async exportPricingApprovalUnit(id: number): Promise<void> {
    const res = await http.get(
      "api/Export/PricingApproval/ExportPricingApprovalUnit",
      { params: { id }, responseType: "blob" }
    )
    downloadFile(
      res.data,
      `PRICING-APPROVAL-UNIT-${id}-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }

  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/PricingApproval/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async active(id: number, isActive: boolean) {
    const res = await http.post(
      "api/services/app/PricingApproval/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post(
      "api/services/app/PricingApproval/BulkActive",
      id
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async getOverview(id: number, body?: any): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.post(
      "api/services/app/PricingApproval/GetOverview",
      body,
      {
        params: { id },
      }
    )
    const { result } = res.data
    return result
  }

  public async assignUnit(body: any) {
    const res = await http.post(
      "api/services/app/PricingApproval/AssignUnit",
      body
    )    
    return res.data.result
  }
  public async getListUnitPricingHistory(params: any) {
    const res = await http.get(
      "api/services/app/PricingApproval/GetListUnitPricingHistory",
      {
        params,
      }
    )
    return res.data.result
  }
}

export default new PricingApprovalService()
